import React, { useEffect, useState } from 'react';
import DG_Form from "../../../../../custom/data-entry/form";
import { useForm } from "antd/es/form/Form";
import DG_Submit from "../../../../../common/button/Submit";
import DG_Button from "../../../../../common/button/Button";
import General from "./General";
import SettingAPI from "./SettingAPI";
import Other from "./Other";
import { loadTimekeepingCommonConfigApi } from "../../../../../api/setting/timekeeping";
import dayjs from "dayjs";
import { Col, Collapse, Divider, Row } from "antd";
import Header from "../../../application/general/components/common/Header";
import { t } from "i18next";
import DG_Cancel from "../../../../../common/button/Cancel";
import SubBody from "../../../application/general/components/common/SubBody";
import { getCustomerId } from "../../../../../api/common/customer/api";
import { getMe } from "../../../../../api/system/admin/user-account";
import { BASE_PATH } from "../../../../../custom/axios/config/Url";
import SettingGPS from "./SettingGPS";

const Content = props => {
    const [form] = useForm();
    const [timekeeping, setTimekeeping] = useState(false);
    const [closing, setClosing] = useState(false);
    const { Panel } = Collapse;
    const [loading, setLoading] = useState(false)
    const [urlCodeApi, setUrlCodeApi] = useState("")
    const [attendanceGPS, setAttendanceGPS] = useState(null)

    const onChangeTimeKeeping = (checked) => {
        setTimekeeping(checked);
    }

    const onChangeClosing = (checked) => {
        setClosing(checked);
    }

    useEffect(() => {
        setLoading(true)
        loadTimekeepingCommonConfigApi().then(data => {
            let timekeepingCodeApi = null
            if (getMe() || getMe()?.customerId) {
                getCustomerId(getMe().customerId).then(res => {
                    timekeepingCodeApi = `${BASE_PATH}/dogoo/timekeeping-rest/v2.0/machine/use/log?apiKey=${res.externalReferenceCode}`
                    form.setFieldsValue(mapForm(data, timekeepingCodeApi, res?.externalReferenceCode))
                    setUrlCodeApi(timekeepingCodeApi)
                })
            } else {
                form.setFieldsValue(mapForm(data, timekeepingCodeApi, null))
                setUrlCodeApi(timekeepingCodeApi)
            }
            setClosing(data?.wordLatch === "auto");
            setTimekeeping(data?.timekeepingCode === "personnel code");

        }).finally(() => setLoading(false));


    }, []);

    const mapForm = (from, codeTimekeeping, apikey) => {
        if (Object.keys(from).length === 0) {
            return {};
        }
        let splitlineFulls = [];
        from.splitlineFulls?.map((item) => {
            splitlineFulls.push(item.splitlineHr)
        })
        setAttendanceGPS(from?.attendanceGPS)
        return ({
            timekeepingCode: from.timekeepingCode,
            lastpersonnelcode: from?.lastpersonnelcode,
            startmonthly: from?.startmonthly,
            time: from?.timeclosingHour === 0 && from?.timeclosingMinute === 0 ? null : dayjs(from?.timeclosing, "H:mm"),
            showtimesheet: from?.showtimesheet === "overtime work" ? "shift work" : from?.showtimesheet,
            codetimekeepingapi: apikey,
            splitline: splitlineFulls,
            roundingFactor: from?.roundingFactor,
            advanceWorkDay: from?.advanceWorkDay,
            wordLatch: from?.wordLatch,
            roundingMinuteSoon: from?.roundingMinuteSoon || 0,
            roundingMinuteLate: from?.roundingMinuteLate || 0,
            closingDate: from?.closingDate === 0 ? null : from?.closingDate,
            attendanceGPS: from?.attendanceGPS
        })
    }
    return (
        <DG_Form
            layout={"horizontal"}
            success={false}
            form={form}
            mode={props.mode}
            onFinish={props.onFinish}
            className={"form-hrmConfig  rounded-tl-[8px] rounded-tr-[8px]"}
            style={{
                background: "#fff",
                borderRight: "1px solid #EAECF0",
                borderLeft: "1px solid #EAECF0",
                borderTop: "1px solid #EAECF0",
                height: "100%",
                overflow: "hidden",
            }}
        >
            <DG_Button title={t("tnp.components.timekeeping.text20")} isHasScroll={true}>
                <DG_Cancel />
                <DG_Submit loading={props?.loading || loading} />
            </DG_Button>

            <div className={'h-full overflow-auto'}>
                <Row>
                    <Col xs={24} sm={24} xl={18}>
                        <SubBody>

                            <Collapse
                                defaultActiveKey={['1']}
                                expandIconPosition={'end'}
                                className={"setting-hrmConfig"}
                                bordered={false}
                            >
                                <Panel key="1"
                                    header={
                                        <Header>{t("timeKeeping-setting.timeKeeping-setting.general-settings-header")}</Header>}>
                                    <General
                                        timeKeeping={timekeeping}
                                        onChangeTimeKeeping={onChangeTimeKeeping}
                                        url={urlCodeApi}
                                    />
                                </Panel>
                            </Collapse>

                            <Collapse

                                defaultActiveKey={['1']}
                                expandIconPosition={'end'}
                                className={"setting-hrmConfig "}
                                bordered={false}
                            >
                                <Panel key="1"
                                    header={
                                        <Header>{t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.setting-gps-header")}</Header>
                                    }>
                                    <SettingGPS attendanceGPS={attendanceGPS} />
                                </Panel>
                            </Collapse>

                            {/*<Collapse*/}

                            {/*    defaultActiveKey={['1']}*/}
                            {/*    expandIconPosition={'end'}*/}
                            {/*    className={"setting-hrmConfig "}*/}
                            {/*    bordered={false}*/}
                            {/*>*/}
                            {/*    <Panel key="1"*/}
                            {/*           header={*/}
                            {/*               <Header>{t("timeKeeping-setting.timeKeeping-setting.api-time-keeping.api-time-keeping-header")}</Header>*/}
                            {/*           }>*/}
                            {/*        <SettingAPI/>*/}
                            {/*    </Panel>*/}
                            {/*</Collapse>*/}

                            <Collapse

                                defaultActiveKey={['1']}
                                expandIconPosition={'end'}
                                className={"setting-hrmConfig "}
                                bordered={false}
                            >
                                <Panel key="1"
                                    header={
                                        <Header>{t("timeKeeping-setting.timeKeeping-setting.other-settings.other-settings-header")}</Header>
                                    }>
                                    <Other
                                        closing={closing}
                                        onChangeClosing={onChangeClosing}
                                    />
                                </Panel>
                            </Collapse>
                        </SubBody>
                    </Col>
                </Row>
            </div>
        </DG_Form>
    );
};

Content.propTypes = {};

export default Content;
